export const QUESTION_TYPES = [
  { value: "BOOLEAN", label: "Yes / No" },
  { value: "SINGLE_SELECT", label: "Single choice" },
  { value: "MULTI_SELECT", label: "Multiple choice" },
  { value: "TEXT", label: "Text" },
  { value: "NUMBER", label: "Number" },
  { value: "DATE", label: "Date" },
  { value: "FILE", label: "Photo upload" },
  { value: "INFO", label: "Info screen (no answer)" },
  { value: "WIDGET", label: "Widget" },
];

export const CONDITION_OPS = [
  { value: "eq", label: "equals" },
  { value: "ne", label: "not equals" },
  { value: "in", label: "is one of" },
  { value: "nin", label: "is none of" },
  { value: "gt", label: ">" },
  { value: "gte", label: ">=" },
  { value: "lt", label: "<" },
  { value: "lte", label: "<=" },
  { value: "answered", label: "was answered" },
];

export const WIDGET_TYPES = [{ value: "REFILL_MED_PICKER", label: "Refill medication picker" }];

export const CHECKOUT_FEATURES = [
  { key: "doctorNote", label: "Doctor Note", description: "Doctor's note add-on price" },
  { key: "rushNote", label: "Rush Note", description: "Faster note delivery price" },
];

// Pricing-only: features are always offered; sku=null = the global default
// membership prices it. baseSku90 = optional 2nd flat tier (Prescription Refill
// 90-day) — null for every other visit type.
export const emptyCheckout = () => ({
  baseSku: null,
  baseSku90: null,
  features: CHECKOUT_FEATURES.reduce(
    (features, feature) => ({ ...features, [feature.key]: { sku: null } }),
    {}
  ),
});

export const normalizeCheckout = (checkout) => {
  const base = emptyCheckout();
  if (!checkout) return base;
  return {
    baseSku: checkout.baseSku ?? null,
    baseSku90: checkout.baseSku90 ?? null,
    features: CHECKOUT_FEATURES.reduce(
      (features, feature) => ({
        ...features,
        [feature.key]: { sku: checkout.features?.[feature.key]?.sku ?? null },
      }),
      {}
    ),
  };
};

/** "true"/"false" → boolean, numeric strings → number, otherwise raw string. */
export const parseConditionValue = (raw) => {
  const value = String(raw ?? "").trim();
  if (value === "true") return true;
  if (value === "false") return false;
  if (value !== "" && !isNaN(Number(value))) return Number(value);
  return value;
};

/** For in/nin: comma-separated list → array of parsed values. */
export const parseConditionValueForOp = (op, raw) => {
  if (op === "in" || op === "nin") {
    return String(raw ?? "")
      .split(",")
      .map((part) => parseConditionValue(part))
      .filter((part) => part !== "");
  }
  return parseConditionValue(raw);
};

export const conditionValueToText = (value) =>
  Array.isArray(value) ? value.join(", ") : value === null || value === undefined ? "" : String(value);
